import { useAuth } from '@/context/AuthContext';
import { auth } from '@/lib/firebase';
import { signOut } from 'firebase/auth';
import { Link } from 'react-router-dom';

export default function ClientDashboard() {
  const { user } = useAuth();

  const handleLogout = () => {
    signOut(auth);
  };

  return (
    <div className="min-h-screen bg-slate-900 text-white font-sans">
      <nav className="bg-slate-800/50 backdrop-blur-md p-4 border-b border-slate-700 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span className="text-2xl font-bold bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
            Smart CRM
          </span>
          <span className="bg-purple-500/10 text-purple-400 text-xs px-2 py-1 rounded-full font-medium border border-purple-500/20">
            Cliente
          </span>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-slate-300 text-sm hidden md:block">{user?.email}</span>
          <button
            onClick={handleLogout}
            className="px-4 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg transition-colors text-sm font-medium"
          >
            Cerrar Sesión
          </button>
        </div>
      </nav>
      
      <main className="p-8">
        <header className="mb-8">
          <h2 className="text-3xl font-bold">Mi Portal</h2>
          <p className="text-slate-400 mt-1">Bienvenido a tu espacio personal.</p>
        </header>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700">
            <h3 className="text-xl font-semibold mb-4 text-slate-200">Mis Datos</h3>
            <div className="space-y-3">
              <div>
                <p className="text-sm text-slate-400">Correo Electrónico</p>
                <p className="font-medium text-slate-200">{user?.email}</p>
              </div>
              <div>
                <p className="text-sm text-slate-400">Estado de Cuenta</p>
                <span className="bg-emerald-500/10 text-emerald-500 text-xs px-2 py-1 rounded-full font-medium border border-emerald-500/20">
                  Activo
                </span>
              </div>
            </div>
          </div>
          
          <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700">
            <h3 className="text-xl font-semibold mb-4 text-slate-200">Productos Disponibles</h3>
            <p className="text-slate-400 mb-6">Explora nuestro catálogo de productos y soluciones digitales para tu negocio.</p>
            <Link to="/products" className="inline-block px-5 py-2.5 bg-gradient-to-r from-emerald-500 to-cyan-500 hover:from-emerald-600 hover:to-cyan-600 rounded-lg font-medium transition-all shadow-lg shadow-emerald-500/20 transform hover:scale-[1.02] text-center text-white">
              Ver Productos
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
